import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import * as actions from 'pages/CommunitySelectedPage/actions';
import { useActions } from 'hooks/useActions';
import { Container } from 'components/Layout/Layout';
import { RankList } from 'components/RankList/RankList';
import { ContentContainer, RankListContainer } from 'pages/CommunitySelectedPage/styles';
import { ChallengeName, Wrapper, Logo, HeaderContainer, CenteringWrapper } from './styles';
import { Images } from 'assets/images';

export default function Hackathon() {
  const params = useParams();
  const id = params.id;
  const { getChallenge } = useActions(actions);

  const { selectedItem } = useSelector((state) => state.CommunitySelectedPageReducer);

  useEffect(() => {
    getChallenge(id, 'challenges');
  }, [getChallenge, id]);

  const renderTopList =
    selectedItem.rankList && selectedItem.rankList.length ? (
      <CenteringWrapper>
        <Container column full>
          <ContentContainer center>
            <RankListContainer>
              <RankList isTournament={selectedItem.isTournament} rankList={selectedItem.rankList} isHackathon />
            </RankListContainer>
          </ContentContainer>
        </Container>
      </CenteringWrapper>
    ) : (
      <p>No top list</p>
    );
  return (
    <CenteringWrapper>
      <Wrapper full column center padding>
        <HeaderContainer>
          <Logo src={Images.logoBlue} />
          <ChallengeName>{selectedItem.name}</ChallengeName>
          <Logo src={selectedItem?.landingPageLogo ?? ''} />
        </HeaderContainer>
        {renderTopList}
      </Wrapper>
    </CenteringWrapper>
  );
}
